import type { FeatureConfig } from 'hb-builder/types';

const style = { mr: { s: 0, m: 5, l: 6 }, mt: { s: 6, m: 0 } };

export interface InitialImage {
  caption: string;
  imageAlt: string;
  index: number;
  mr?: typeof style.mt;
  mt?: typeof style.mt;
  size?: string;
  url?: string;
}

export const INITIAL_IMAGES = ({
  features,
}: {
  features?: FeatureConfig;
}): InitialImage[] => [
  {
    caption: '',
    imageAlt: '',
    index: 0,
    mr: style.mr,
    size: 'big',
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_7.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img1.jpeg',
  },
  {
    caption: '@Elena Koycheva',
    imageAlt: '',
    index: 1,
    mr: style.mt,
    mt: style.mt,
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_6.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img2.jpeg',
  },
  {
    caption: '',
    imageAlt: '',
    index: 2,
    mt: style.mt,
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_5.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img3.jpeg',
  },
  {
    caption: 'Marc and Caroline in workshop - @aranxa_esteve',
    imageAlt: '',
    index: 3,
    mt: style.mt,
    size: 'big',
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_4.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img4.jpeg',
  },
  {
    caption: '',
    imageAlt: '',
    index: 4,
    mr: style.mt,
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_3.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img6.jpeg',
  },
  {
    caption: '',
    imageAlt: '',
    index: 5,
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_2.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img5.jpeg',
  },
  {
    caption: '',
    imageAlt: '',
    index: 6,
    mr: style.mr,
    mt: style.mt,
    size: 'big',
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img_1.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img7.jpeg',
  },
  {
    caption: '',
    imageAlt: '',
    index: 7,
    mt: style.mt,
    size: 'big',
    url: features?.panel?.inPanel
      ? '/images/missing/image_galleries/low_quality_images/Img.jpg'
      : '/images/missing/image_galleries/hight_quality_images/img8.jpeg',
  },
];
